import { createSelector } from "reselect";
import _ from "lodash";
import moment from 'moment';

export const createSelectors = parentReducer => {
    return new class {
        selectClientDetails = store => {
            const MainReducer = store["MainReducer"];
            let profile = MainReducer.profile;
            if (profile) {
                return profile
            }
            return false
        };
        selectReportTitles = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["AlertsWidgetReportAlerts_reducer"];
            return reducer.reportTitles;
        };
        getRequesting = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["AlertsWidgetReportAlerts_reducer"];
            return reducer.requesting;
        };

        selectAlert = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["AlertsWidgetReportAlerts_reducer"];
            return reducer.alerts;
        };
        selectAlerts = createSelector([this.selectAlert], (alerts = false) => {
            let refArray = []
            if(alerts){
                Object.values(alerts).map((e)=>{
                    let refObj = e;
                    let refdate = moment(e.timestamp, "DD-MM-YYYY HH:mm:ss")
                    let uneditable = e.uneditable ? e.uneditable : false;
                    refObj['utc'] = parseInt((new Date(refdate).getTime() / 1000).toFixed(0))
                    refObj['uneditable'] = uneditable
                    refArray.push(refObj)
                    return null;
                })
                return  _.orderBy(refArray, "utc", ["desc"]);   
            }
        })
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["AlertsWidgetReportAlerts_reducer"];
            return reducer.users;
        };
        selectFilter = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["AlertsWidgetReportAlerts_reducer"];
            return reducer.statusFilter;
        };
        
        selectUserInfo = createSelector(
            [this.selectUsers],
            (users = false) => {
                if (users) {
                    let userInfo = Object.keys(users).map(e => {
                        let uid = e;
                        let fname =
                            _.get(users[e], "profile.first_name") || "N/A";
                        let lname =
                            _.get(users[e], "profile.last_name") || "N/A";
                        return { uid, name: `${fname} ${lname}` };
                    });
                    return userInfo;
                } else {
                    return false;
                }
            }
        );
    }();
};

export const clientDetails = ({ MainReducer }) => {
    let profile = MainReducer.profile;
    if (profile) {
        return profile
    }
    return false
};
export default createSelectors;
